'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';

const PreviewLink = ({ enterPreview, exitPreview, isPreviewModeServer }: { enterPreview: () => void; exitPreview: () => void; isPreviewModeServer: boolean }) => {
  const [isPreviewMode, setIsPreviewMode] = useState(isPreviewModeServer);
  const router = useRouter();
  const buttonText = isPreviewMode ? 'Preview beenden' : 'Preview Inhalt';

  const handlePreview = () => {
    if (isPreviewMode) {
      setIsPreviewMode(false);
      exitPreview();
    } else {
      setIsPreviewMode(true);
      enterPreview();
    }

    router.refresh();
  };

  return <button onClick={() => handlePreview()}>{buttonText}</button>;
};

export { PreviewLink };
